import { render, staticRenderFns } from "./BudgetForm.vue?vue&type=template&id=31fcc81e&"
import script from "./BudgetForm.vue?vue&type=script&lang=js&"
export * from "./BudgetForm.vue?vue&type=script&lang=js&"
import style0 from "./BudgetForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports